export default __webpack_public_path__ + "6fcac502ff0be9b6c6f3c70a0c26fd49.png";